function addToBundle(modal) {
  const addBtn = modal.querySelector(
    ".product-form__buttons .product-form__submit"
  );
  const submitBtn = modal.querySelector(
    ".product-form__buttons .product-form__submit span:first-child"
  );
  const subscriptionWidget = modal.querySelector(".custom_recharge_widget");
  const quantitySelect = modal.querySelector(".quantity__select");

  if (quantitySelect) quantitySelect.style.display = "none";
  if (subscriptionWidget) subscriptionWidget.style.display = "none";
  if (submitBtn) submitBtn.textContent = "Add to Bundle";

  addBtn.addEventListener("click", function (event) {
    event.preventDefault();

    const activeVariantEl = modal.querySelector(".item_price_label.active");
    const productVariant =
      activeVariantEl?.querySelector("h6")?.innerText?.trim() || "";
    const mainPriceAttr = modal
      .querySelector(".item_price_label.active label")
      ?.getAttribute("variantprice");
    // console.log("mainPriceAttr", mainPriceAttr);

    const mainPrice = parsePrice(mainPriceAttr);
    const productTitle =
      modal.querySelector(".product_title")?.innerText?.trim() || "";
    const formProductID =
      modal.querySelector(".form input[name='id']")?.value || "";
    const featuredImage = modal.querySelector(".swiper-slide img")?.src || "";

    const emptyBox = document.querySelector(
      ".selected_products .box_product_item.is_empty"
    );
    if (!emptyBox) {
      alert("All bundle slots are filled!");
      return;
    }

    // Fill box data
    emptyBox.classList.remove("is_empty");
    emptyBox.classList.add("in_bundle");
    emptyBox.setAttribute("variantID", formProductID);
    emptyBox.querySelector(".box_thumb img").src = featuredImage;
    emptyBox.querySelector(".box_content h6").textContent = productTitle;
    emptyBox.querySelector(
      ".product_price"
    ).textContent = `$${mainPrice.toFixed(2)}`;
    emptyBox.querySelector(".product_varinat").textContent = productVariant;

    // Add class to the selected product card on grid
    const allProducts = document.querySelectorAll(".product_item");
    allProducts.forEach((p) => {
      const idInputs = p.querySelectorAll("input[name='id']");
      idInputs.forEach((idInput) => {
        if (idInput.value.trim() === String(formProductID).trim()) {
          p.classList.add("in_bundle");
          // console.log("Added in_bundle for:", idInput.value);
        }
      });
    });

    modal.style.display = "none";
    document.body.style.overflow = "auto";
    updateBundleStatus();
    wrapSpecialCharsInSup(window.supSelectors, window.supChars);
  });
}
function parsePrice(text) {
  if (!text) return 0;
  const clean = text
    .toString()
    .replace(/[^0-9.]/g, "")
    .trim();
  const num = parseFloat(clean);
  return isNaN(num) ? 0 : num;
}
function handleRemoveProduct() {
  document.addEventListener("click", function (e) {
    if (e.target.closest(".remove_box_product")) {
      const item = e.target.closest(".box_product_item");
      const removedID = item.getAttribute("variantID");

      item.classList.remove("in_bundle");
      item.classList.add("is_empty");
      item.setAttribute("variantID", "");
      item.querySelector(".box_thumb img").src = "";
      item.querySelector(".box_content h6").textContent = "Add a product";
      item.querySelector(".product_price").textContent = "$32.99";
      item.querySelector(".product_varinat").textContent = "48 Capsules";

      // Remove .in_bundle class from product grid
      const allProducts = document.querySelectorAll(".product_item.in_bundle");
      allProducts.forEach((p) => {
        const idInputs = p.querySelectorAll("input[name='id']");
        idInputs.forEach((idInput) => {
          if (idInput.value.trim() === String(removedID).trim()) {
            p.classList.remove("in_bundle");
            // console.log("Removed in_bundle for:", idInput.value);
          }
        });
      });

      setTimeout(() => {
        const stillInBundle = Array.from(
          document.querySelectorAll(".box_product_item.in_bundle")
        ).some((box) => box.getAttribute("variantID") === String(removedID));
        if (stillInBundle) {
          const allProducts = document.querySelectorAll(".product_item");
          allProducts.forEach((p) => {
            const idInputs = p.querySelectorAll("input[name='id']");
            idInputs.forEach((idInput) => {
              if (idInput.value.trim() === String(removedID).trim()) {
                p.classList.add("in_bundle");
              }
            });
          });
        } else {
          // console.log("Variant fully removed:", removedID);
        }
      }, 100);
      
      updateBundleStatus();
      wrapSpecialCharsInSup(window.supSelectors, window.supChars);
    }
  });
}
function updateBundleStatus() {
  const mainBundleWrapper = document.querySelector(".azo_byob");
  const box = document.querySelector(".selected_products .product_box");
  const items = box.querySelectorAll(".box_product_item.in_bundle");
  const count = items.length;

  const titleH5 = box.querySelector(".box_header .box_title h5");
  const titleSpan = box.querySelector(".box_header .box_title span");
  const subTitle = box.querySelector(".box_header .box_sub_title");
  const subTitle2 = box.querySelector(".box_header .box_sub_title2");
  const footerH6 = box.querySelector(".box_footer h6");
  const originalPriceEl = box.querySelector(".box_footer .original_price");
  const discountPriceEl = box.querySelector(".box_footer .discount_price");
  const boxBadge = box.querySelector(".box_footer .box_badge");
  const checkoutBtn = box.querySelector(".checkout_btn");

  let total = 0;
  items.forEach((item) => {
    const priceText = item.querySelector(".product_price")?.textContent || "";
    const price = parsePrice(priceText);
    total += price;
  });

  // console.log("Bundle total:", total);

  originalPriceEl.textContent = `$${total.toFixed(2)}`;
  originalPriceEl.style.display = count > 0 ? "inline-block" : "none";
  if (count < 3) {
    originalPriceEl.classList.add("calculating_price");
    mainBundleWrapper.classList.remove("bundle_complete");
  } else if (count >= 3) {
    mainBundleWrapper.classList.add("bundle_complete");
    originalPriceEl.classList.remove("calculating_price");
  }

  if (count === 0) {
    titleH5.textContent = "Get started";
    subTitle.textContent = "Mix & Match 3 products";
    subTitle2.style.display = "none";
    titleSpan.textContent = "(0 of 3)";
    footerH6.textContent = "Your bundle is empty";
    discountPriceEl.textContent = "$0.00";
    discountPriceEl.style.display = "none";
    boxBadge.style.display = "none";
    checkoutBtn.disabled = true;
  } else if (count === 1) {
    titleH5.textContent = "Keep going";
    subTitle.textContent = "Add 1 more product to get 10% off";
    subTitle2.style.display = "none";
    titleSpan.textContent = "(1 of 3)";
    footerH6.textContent = "Total price for your bundle";
    discountPriceEl.style.display = "none";
    boxBadge.style.display = "none";
    checkoutBtn.disabled = true;
  } else if (count === 2) {
    titleH5.textContent = "Almost there";
    subTitle.textContent = "Add 1 more product to get 15% off";
    subTitle2.style.display = "block";
    subTitle2.textContent = "Checkout now";
    titleSpan.textContent = "(2 of 3)";
    footerH6.textContent = "Total price for your bundle";
    discountPriceEl.style.display = "none";
    boxBadge.style.display = "none";
    checkoutBtn.disabled = true;
    const discount = total * 0.90;
    discountPriceEl.textContent = `$${discount.toFixed(2)}`;
    discountPriceEl.style.display = "inline-block";
    boxBadge.textContent = "-10%";
    boxBadge.style.display = "inline-block";
    checkoutBtn.disabled = false;
    originalPriceEl.classList.remove("calculating_price");

  } else if (count === 3) {
    titleH5.textContent = "You’re ready";
    subTitle2.style.display = "none";
    subTitle.textContent = "AZO® has your back, checkout now";
    titleSpan.textContent = "(3 of 3)";
    footerH6.textContent = "Total price for your bundle";
    
    const discount = total * 0.85;
    discountPriceEl.textContent = `$${discount.toFixed(2)}`;
    discountPriceEl.style.display = "inline-block";
    boxBadge.textContent = "-15%";
    boxBadge.style.display = "inline-block";
    checkoutBtn.disabled = false;

  }
}
function handleGridRemove() {
  document.addEventListener("click", function (e) {
    const checkBtn = e.target.closest(".product_item.in_bundle .check_btn");
    if (!checkBtn) return;

    const productItem = checkBtn.closest(".product_item.in_bundle");

    const variantInputs = productItem.querySelectorAll("input[name='id']");
    const variantIDs = Array.from(variantInputs)
      .map((input) => input.value.trim())
      .filter(Boolean);

    // console.log("Found variant IDs to remove:", variantIDs);

    if (variantIDs.length === 0) return;

    const bundleBoxes = document.querySelectorAll(
      ".selected_products .box_product_item.in_bundle"
    );
    let removedCount = 0;

    bundleBoxes.forEach((box) => {
      const boxVariantID = box.getAttribute("variantID");
      if (variantIDs.includes(boxVariantID)) {
        box.classList.remove("in_bundle");
        box.classList.add("is_empty");
        box.setAttribute("variantID", "");
        box.querySelector(".box_thumb img").src = "";
        box.querySelector(".box_content h6").textContent = "Add a product";
        box.querySelector(".product_price").textContent = "$32.99"; // default price
        box.querySelector(".product_varinat").textContent = "48 Capsules"; // default variant
        removedCount++;
      }
    });
    // console.log(`🗑️ Removed ${removedCount} bundle box(es) for variantIDs:`, variantIDs);
    productItem.classList.remove("in_bundle");
    // console.log("Removed .in_bundle class from product card containing variants:", variantIDs);
    updateBundleStatus();
    wrapSpecialCharsInSup(window.supSelectors, window.supChars);
  });
}

function handleBundleCheckout() {
  document.addEventListener("click", async function (e) {
    const checkoutBtn = e.target.closest(".checkout_btn");
    if (!checkoutBtn) return;
    const bundleItems = document.querySelectorAll(
      ".box_product_item.in_bundle"
    );
    if (bundleItems.length < 2) {
      alert("Please add all 3 products to your bundle before checkout.");
      return;
    }
    const bundleID = `bundle_${Date.now()}`;
    const packNum = Math.round(Math.random() * 10000);
    const items = Array.from(bundleItems).map((item) => ({
      id: item.getAttribute("variantID"),
      quantity: 1,
      properties: {
        "_Bundle Pack": packNum,
      },
    }));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error("Error adding bundle product to cart");
      const data = await res.json();
      updateCartDrawer();

      const htmlRes = await fetch(window.location.href);
      const htmlText = await htmlRes.text();
      const htmlDoc = new DOMParser().parseFromString(htmlText, "text/html");
      const byobHtml = htmlDoc.querySelector(".azo_byob")?.innerHTML;

      if (byobHtml) {
        document.querySelector(".azo_byob").innerHTML = byobHtml;
        document.querySelector(".azo_byob").classList.remove("bundle_complete");
        bindQuickViewButtons();
        initByobScripts();
      }
    } catch (error) {
      // console.error("Error adding bundle product to cart:", error);
      alert("Error adding bundle to cart");
    }
  });
}
handleGridRemove();
handleRemoveProduct();
handleBundleCheckout();

function initByobScripts() {
  // --- Intersection Observer setup ---
  const targetDiv = document.querySelector(".selected_products");
  const section = document.querySelector(".azo_byob");

  if (targetDiv && section) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            targetDiv.classList.add("active");
          } else {
            targetDiv.classList.remove("active");
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
  }

  // --- Product box accordion setup ---
  const boxes = document.querySelectorAll(".product_box");
  boxes.forEach((box) => {
    const header = box.querySelector(".box_header");
    const content = box.querySelector(".product_box_content");

    if (header && content) {
      header.addEventListener("click", () => {
        if (window.innerWidth < 767) {
          box.classList.toggle("active");
          header.classList.toggle("active");
          content.style.maxHeight = box.classList.contains("active")
            ? content.scrollHeight + "px"
            : "0";
        }
      });
    }
  });
}
initByobScripts();

async function fetchAndReplaceHtml(newContentBlock) {
  const url = window.Shopify.routes.root + "cart?section_id=cart-drawer";
  const response = await fetch(url);
  const responseText = await response.text();
  // console.log(responseText);
  const newHtml = new DOMParser()
    .parseFromString(responseText, "text/html")
    .getElementById("CartDrawer").innerHTML;
  document.getElementById(newContentBlock).innerHTML = newHtml;
  return newHtml;
}

async function updateCartDrawer() {
  const newHtml = await fetchAndReplaceHtml("CartDrawer");
  // console.log("newHtml=", newHtml);
  const cartDrawer = document.querySelector("cart-drawer");
  getRecomandProduct();
  var bundle_product_title = $("#bundle_product_title").val();
  var bundle_product_id = $("#bundle_product_id").val();
  var bundle_variant_id = $("#bundle_variant_id").val();
  var redeem_cart = $(
    '<product-form class="' +
      bundle_product_title +
      '">' +
      '<form method="post" action="/cart/add" id="quick-add-' +
      bundle_product_id +
      '" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">' +
      '<input type="hidden" name="form_type" value="product">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="id" value="' +
      bundle_variant_id +
      '">' +
      '<button id="quick-add-' +
      bundle_product_id +
      '-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="quick-add-' +
      bundle_product_id +
      "-submit title--" +
      bundle_product_id +
      '" aria-live="polite"' +
      'data-sold-out-message="true" role="button">' +
      "<span>Redeem</span>" +
      '<div class="custom_loading loading-overlay hidden">' +
      '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
      '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
      "</svg>" +
      "</div>" +
      "</button>" +
      '<input type="hidden" name="product-id" value="' +
      bundle_product_id +
      '">' +
      "</form>" +
      "</product-form>"
  );
  $(".free-gift-product .free-image .quick-add.no-js-hidden").html(redeem_cart);
  cartDrawer.classList.remove("is-empty");
  cartDrawer.classList.add("animate", "active");
}
